function Footer() {
    return <footer>
        DERECHOS RESERVADOS @ 2023 | DTIC UMSS
    </footer>
}

export default Footer